import { render } from "./MemberInfoCard.vue?vue&type=template&id=0e574c03&scoped=true"
import script from "./MemberInfoCard.vue?vue&type=script&lang=js"
export * from "./MemberInfoCard.vue?vue&type=script&lang=js"

import "./MemberInfoCard.vue?vue&type=style&index=0&id=0e574c03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e574c03"]])

export default __exports__